import styled from 'styled-components';

import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { Grid, Button } from '@simplywallst/ui-core';

export const TooltipTextWrapper = styled(Grid)`
  max-width: 260px;

  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x3spacePx / 2}px;
`;

export const InformationIcon = styled(InformationSolid)`
  cursor: help;
  display: inline-block;
`;

export const AddButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.color.brand01};
  ${({ theme }) => theme.typography.xSmall}
  > svg {
    fill: ${({ theme }) => theme.color.brand01};
    height: 16px;
    width: 16px;
  }
`;
